import React from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
// import { Link } from 'react-publicRoutes-dom';
import { TextField } from 'components/TextField';
import RecaptchaField from 'components/RecaptchaField';
import { Formik, FormikActions, Field } from 'formik';
import { required } from 'utils/formValidators';

import { Actions as userActions } from 'reducers/user';
import { Actions as appActions } from 'reducers/app';


const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & input {
    max-width: 302px;
  }

  @media (max-width: 500px) {
    align-items: center;
  }
`;

const LoginButton = styled.button`
  max-width: 302px !important;
  width: 100% !important;
  cursor: pointer;
  margin-top: 20px;
`;

interface IValues {
  email: string;
  recaptcha: string;
}

type Props = typeof actions;

const LoginForm: React.FC<Props> = ({ restorePassword, toggleBlockUI }) => {
    const onSubmit = (values: IValues, { resetForm }: FormikActions<IValues>) => {
      toggleBlockUI(true);
      restorePassword(values, resetForm);
    };

    return (
      <div className="main-tab block-open">
        <Formik
          initialValues={{
            email: '',
            recaptcha: '',
          }}
          onSubmit={onSubmit}
          >
            {({
              handleSubmit,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Field
                  placeholder="Ваш Email"
                  type="text"
                  name="email"
                  component={TextField}
                  validate={required}
                />
                <Field
                  name="recaptcha"
                  component={RecaptchaField}
                  validate={required}
                />
                <div className="main-top__row">
                  <LoginButton type="submit" className="main-top__btn btn-main">Восстановить</LoginButton>
                  {/* <Link to={'/auth/login'} className="main-top__link">Назад</Link> */}
                </div>
              </Form>
            )}
          </Formik>
      </div>
    );
  };

const actions = {
  restorePassword: userActions.restorePassword,
  toggleBlockUI: appActions.toggleUIBlocking,
};

export default connect(null, actions)(LoginForm);
